import { defineMessages } from 'react-intl';

export default defineMessages({
	exploreAll: {
		defaultMessage: 'Show more portals ({remainingCount, number})',
		description: 'Text message for Explore all button to load additional project cards',
		id: 'cv.portal.card.layout.list.explore.all.button',
	},
	collapseOtherProjects: {
		defaultMessage: 'Show fewer',
		description:
			'Text message for Collapse other projects button to collapse other projects section',
		id: 'cv.portal.card.layout.list.collapse.button',
	},
	featuredPortalsLabel: {
		defaultMessage: 'Featured portals',
		description: 'Text message for featured portals section',
		id: 'cv.portal.card.layout.list.featured.portals.title',
	},
	remainingProjectsByName: {
		defaultMessage: 'More portals',
		description:
			'The text is shown as the section heading for additional portals listed alphabetically by name in the featured and sorted portals card list on the help center home page.',
		id: 'cv.portal.card.layout.list.remaining.projects.by.name.title',
	},
	remainingPortals: {
		defaultMessage: 'Portals',
		description:
			'The text is shown as the section heading for the remaining portals list in the help center home page when no specific sort order is applied.',
		id: 'cv.portal.card.layout.list.remaining.portals',
	},
});
